
import React, { useState, useEffect, useRef, useCallback, useReducer } from 'react';
import axios from 'axios';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import { Notifications, Help, ArrowDropDown, Upload, UploadFileOutlined } from '@mui/icons-material';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Avatar,
  Button,
  Badge,
  Box,
  Autocomplete,
  Select,
  Divider,
  Drawer,
  TextField,
  InputLabel,
  FormControl,
  FormControlLabel,
  Checkbox,
  InputAdornment,
  Paper
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import Search from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import ClearIcon from '@mui/icons-material/Clear';
import ManageKeywords from './ManageKeywords';
import ToggleSplitPane from '../components/ToggleSplitPane';
import PdfViewerComponent from './PdfViewerComponent';
import AlertNotification from '../components/AlertNotification';
import SearchCase from '../TestModules/SearchCase';

import {
  TextFieldWithIconButton,
  UtilityLibrary,
  ApiManager,
  sessionService,
  SessionManager,
  PageLoader,
  DocumentUtility,
  EnumUtility,
  NotificationDialog,
  DeterminePermissions,
  ErrorModel,
  LoggerUtility,
  CommonDialog,
} from '../components/ComponentsLibrary';
import { findAllByDisplayValue } from '@testing-library/react';
import { json } from 'react-router-dom';


const ManageTestComponents = ({ }) => {

  const [pageTitleCurrent, setPageTitleCurrent] = useState("YTrac :: Test Page");


  useEffect(() => {
    document.title = pageTitleCurrent;
  }, [pageTitleCurrent]);


  const masterServerDBSchema_Name = "YTracG2_Master.dbo"; // CODE_MODIFY: Modify the Master Server DB name


  const [leftPaneTitle, setLeftPaneTitle] = useState("Test Component");
  const [rightPaneTitle, setRightPaneTitle] = useState("Document Viewer");

  const [notificationDialogOpen, setNotificationDialogOpen] = useState(false);
  const [notificationDialogContent, setNotificationDialogContent] = useState([]);

  const [isPageLoading, setIsPageLoading] = useState(false);

  const customDateFormat = "MM/DD/YYYY hh:mm A";

  const handleTestErrorClick = async () => {
    try {
      await TestMethod();
      const tempValue = 'abc' / 100;
      console.log(tempValue);
    }
    catch (error) {
      const errorLog = LoggerUtility.ProcessErrorData(error, "handleTestErrorClick", {});
      errorLog.name = "Manage Test Components";
      const logPost = LoggerUtility.SendErrorDataToApi(errorLog);
      console.log(logPost);
      LoggerUtility.SendLogsToAppInsights(errorLog);
    }
  };

  const TestMethod = async () => {
    try {
      await TestMethod2();
      await TestMethod3();
     // const getValue = ApiManager.BatchDocumentsApiUrl();
    }
    catch (error) {
      throw LoggerUtility.ProcessErrorData(error, "TestMethod", {});
    }
  };

  const TestMethod2 = async () => {
    try {
      return true;
    }
    catch (error) {
      throw LoggerUtility.ProcessErrorData(error, "TestMethod2", {});
    }
  };

  const TestMethod3 = async () => {
    try {
      const getValue = ApiManager.BatchDocumentsApiUrl();
    }
    catch (error) {
      throw LoggerUtility.ProcessErrorData(error, "TestMethod3", {});
    }
  };

  
  const handleTestError2Click = async () => {
    try {
      const getValue = ApiManager.BatchDocumentsApiUrl();
      const tempValue = 'abc' / 100;
      console.log(tempValue);
    }
    catch (error) {
      const errorLog = LoggerUtility.ProcessErrorData(error, "handleTestError2Click", {});
      errorLog.name = "Manage Test Components";
      const logPost = LoggerUtility.SendErrorDataToApi(errorLog);
      console.log(logPost);
      LoggerUtility.SendLogsToAppInsights(errorLog);
    }
  };



  /* 
  const handleTestErrorClick02 = async () => {
    try {       
        const getValue = ApiManager.BatchDocumentsApiUrl();
        const tempValue = 'abc'/100;
        console.log(getValue);
      } catch (error) {
        const errorInfo = new ErrorInfoModel();
        errorInfo.Name = 'New Error';
        errorInfo.Message = error.message;
        errorInfo.Details = {
            functionName: "handleTestErrorClick",
            errorCode: 500,
            extraInfo: "Additional context about the error",
          };
        errorInfo.StackTrace = error.stack;
        errorInfo.ErrorTrace = ["handleTestErrorClick"];
        const errorModel = new ErrorModel(errorInfo);        
        // const getErrorDetails = new ErrorModel(error.message, {
        //     functionName: "Test Method 001",
        //     errorCode: 500,
        //     extraInfo: "Additional context about the error",
        //   });
          const logPost = await ApiManager.PostLogFromWebToApi(errorModel);
        console.log("Error caught in method, rethrowing...: " + logPost);
        throw error; // Rethrow for calling method
      }
  };
 */

  const leftPaneContent = (
    <div className="content-main-container">
      <div className="pane-wrap-container">

        <div className="pane-main-container-v01">
          {/* Header Section */}
          <header className="form-header">
            <div className="text-wrapper-header" style={{ padding: '5px 5px' }}>Test Page</div>
          </header>
          {/* Form Section */}
          <div className='form-content'>
            
          </div>
          {/* Footer Section */}
          <footer className="form-footer">
            <div className="d-flex justify-content-between align-items-center mb-2 form-actions">

              <div className='leftDiv'>
                <Button id="testErrorBtn" name="cancelBtn" variant='outlined' className='me-3' onClick={handleTestErrorClick}>Test Error</Button>
              </div>

              <div className='rightDiv'>
                <Button id="testError2Btn" name="cancelBtn" variant='outlined' className='me-3' onClick={handleTestError2Click}>Test Error 2</Button>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div >
  );

  const rightPaneContent = (
    <div className="content-main-container">
      <div className="pane-wrap-container">
        <div className="pane-main-container">
          <div className="form-section">

          </div>
        </div>
      </div>
    </div >
  );

  return (
    <div>
      <ToggleSplitPane
        leftPaneTitle={leftPaneTitle}
        leftPaneContent={leftPaneContent}
        rightPaneTitle={rightPaneTitle}
        rightPaneContent={rightPaneContent}
        leftPaneSize='50%'
      >
      </ToggleSplitPane>



      {/* Include the loader component */}
      <PageLoader isPageLoading={isPageLoading} />
    </div>
  );
};

export default ManageTestComponents;
